import { DatePicker, DatePickerProps } from '@adamftd/x-date-pickers-pro';
import { Calendar } from 'react-feather';
import IconFeather from 'src/components/common/Icon';

const Icon = () => <IconFeather muiProps={{ fontSize: 'small' }} icon={<Calendar />} />;

const DatePickerWithDefaultIcon = (props: DatePickerProps<any>) => {
  return (
    <DatePicker
      slots={{
        openPickerIcon: Icon,
      }}
      {...props}
    />
  );
};

export default DatePickerWithDefaultIcon;
